import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Selectors } from '@grandvisionhq/auth';
import { useLink } from '@grandvisionhq/frk-routing';
import { WithUserData, isDataLoading } from '@grandvisionhq/my-account';
import { useSelector } from '@grandvisionhq/state';
import { StepLogin } from './StepLogin.js';
import { useCheckoutSettings } from '../context/CheckoutSettings/context.js';

const StepLoginContainer = ({ continueButtonLabel , continueTitle , loginTitle , loginSubtitle , continueSubtitle , backClickLabel , onContinueClick , userData  })=>{
    const checkoutSettings = useCheckoutSettings();
    const { onClick: navigateToCart  } = useLink({
        route: 'cart.overview'
    }, {
        replace: true
    }) || {};
    const isLoggedIn = useSelector(Selectors.isLoggedIn);
    const isLoading = isDataLoading(userData);
    const goBackToStore = React.useCallback(()=>{
        navigateToCart === null || navigateToCart === void 0 ? void 0 : navigateToCart();
    }, [
        navigateToCart
    ]);
    return /*#__PURE__*/ React.createElement(StepLogin, {
        isLoading: isLoading,
        isLoggedIn: isLoggedIn,
        labels: {
            continueTitle,
            continueSubtitle,
            continueButtonLabel,
            loginTitle,
            loginSubtitle,
            backClickLabel
        },
        loginProps: checkoutSettings.login,
        onBackClick: goBackToStore,
        onContinueClick: onContinueClick
    });
};
const StepLoginWithUserData = WithUserData(StepLoginContainer);
const StepLoginWithMyAccountEnabled = (_param)=> {
    var props = swcHelpers.extends({}, _param);
    return React.createElement(StepLoginWithUserData, swcHelpers.extends({}, props, {
        isMyAccountEnabled: true
    }));
};
var StepLoginWithMyAccountEnabled$1 = StepLoginWithMyAccountEnabled;

export { StepLoginContainer, StepLoginWithMyAccountEnabled$1 as default };
//# sourceMappingURL=StepLoginContainer.js.map
